// Maps a row from /rest/v2/event to the shape EventsTable renders. Shared by the
// event history screens and the Clusters screens so both show the same columns.

import EventsDataTable from '../types/instance/tables/EventsDataTable';
import EventType from '../types/instance/EventType';
import HostTarget from '../types/host/HostTarget';

export function toEventsDataTable(event: any, index: number, options: {
    eventTypes?: EventType[],
    host?: HostTarget,
    hosts?: HostTarget[],
} = {}): EventsDataTable {
    let htmlIcon = '';
    if (event.event === 'custom') {
        // Look up the custom event type definition to get its icon
        const eventTypeDef = options.eventTypes?.find(et => et.title === event.type);
        htmlIcon = eventTypeDef?.htmlIconCode || 'fas fa-cog';
    }
    return {
        id: index,
        instanceId: event.datasourceid,
        changeType: event.type,
        changeFrom: event.oldvalue,
        changeTo: event.newvalue,
        title: event.name,
        htmlIconCode: htmlIcon,
        instanceName: event.entity,
        detailsUrl: event.detailsUrl,
        color: event.colourCode,
        details: event.description,
        timeslice: event.timeslice,
        timesliceEnd: undefined,
        event: event.event,
        isHost: !!options.host || event.hostid,
        host: options.host || ((options.hosts?.length && options.hosts.find(h => h.id === event.hostid)) || undefined),
        startedEnded: event.startedended,
        statistic: event.statistic,
        units: event.units,
        threshold: event.threshold,
        decreasing: event.decreasing,
        name: event.name,
        severity: event.severity,
        object: event.object,
        groupName: event.groupname,
        databaseName: event.databasename
    };
}
